// This needs to be imported as the first import by index.ts in order to be hoisted by rspack
// above any other usages of it otherwise it will result in a race conditon - JDL
globalThis.__RENDER_LOCATION__ = "client";
